export * from './setting-page.view';
export * from './theme-page';
export * from './element-page';
export * from './default-setup';
